import { useTranslation } from 'react-i18next';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { Breadcrumb, Button } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { currentKeyword } from '../features/search/searchSlice';

import { HomeOutlined, UserAddOutlined } from '@ant-design/icons';

import BG from '../assets/images/report-list-bg.png';
import { useState, useLayoutEffect } from 'react';
import {Contests} from "../views/Contests";

const Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  /* background-color: #0e0e0e; */
  /* padding: 20px;
  margin-top: 20px;
  border: 1px solid #0e0e0e;
  box-shadow: 0 2px 10px #0e0e0e;
  border-radius: 6px;
  box-sizing: border-box; */
  @media screen and (max-width: 1440px) {
    /* padding: 8px;
    margin: 0 10px;
    margin-top: 20px; */
  }
`;

const Page = styled.div`
  width: 100%;
  height: 100%;
  /* min-height: calc(100vh - 161px);  pageBG*/
  ${(props) =>
    props.isPadding ? `padding: 20px; padding-top:14px;` : `padding: 0;`}
  ${(props) =>
    props.pageBG
      ? `background-color: unset;`
      : `background-color: #0e0e0e;
  border: 1px solid #0e0e0e;
  box-shadow: 0 2px 10px #0e0e0e;`}
  /* padding: 20px; */
  margin-top: 20px;

  border-radius: 6px;
  ${(props) =>
    props.isPadding
      ? `background-image: url(${BG});`
      : `background-image: none;`}
  background-repeat: no-repeat;
`;

const KeyWord = styled.div`
  display: inline-block;
  padding: 3px 5px;
  line-height: 1;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.5);
`;

const NavFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PageContent = ({ children, title }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const _keyWord = useSelector(currentKeyword);
  const [isPadding, setIsPadding] = useState(true);
  const [pageBG, setPageBG] = useState(false);
  const [showAddTeam, setShowAddTeam] = useState(false);
  const user = useSelector((state) => state.user);
  const breadcrumbNameMap = {
    '/': t('home'),
    '/reports': t('breadcrumb.report'),
    '/reports/': t('breadcrumb.detail'),
    '/bounties': t('breadcrumb.Bounties'),
    '/bounties/': t('breadcrumb.bountiesDetail'),
    '/contests': t('breadcrumb.Contests'),
    '/teams': t('breadcrumb.team'),
    '/teams/': t('breadcrumb.teamDetail'),
    '/whitehat-teams': t('breadcrumb.team'),
    '/whiteHats': t('breadcrumb.whiteHats'),
    '/whiteHats/': t('breadcrumb.whiteHatsDetail'),
    '/articles': t('breadcrumb.articles'),
    '/about': t('breadcrumb.about'),
    '/articles/': t('breadcrumb.articlesDetail'),
    '/login': t('breadcrumb.login'),
    '/register': t('breadcrumb.register'),
    '/search': `${t('breadcrumb.search')}: ${_keyWord}`,
    '/addreport': t('breadcrumb.addreport'),
    '/addteam': t('breadcrumb.addteam'),
  };
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  useLayoutEffect(() => {
    if (pathSnippets[0] === 'whiteHats' || pathSnippets[0] === 'team' || pathSnippets[0] === 'whitehat-teams') {
      setIsPadding(false);
    }
    if (
      pathSnippets[0] === 'team' &&
      user &&
      user?.user?.user?.team_id === 0 &&
      user?.user?.user?.level === 1
    ) {
      setShowAddTeam(true);
    }
    if (pathSnippets[0] === 'team' && pathSnippets[1] === 'detail') {
      setPageBG(true);
    }
    if (pathSnippets[0] === 'whiteHats' && pathSnippets[1] === 'detail') {
      setPageBG(true);
    }
    if (pathSnippets[0] === 'contests') {
      setPageBG(true);
      setIsPadding(false);
    }
    if (pathSnippets.length === 1 && pathSnippets[0] === 'whitehat-teams') {
      setPageBG(true);
    }
  }, [pathSnippets]);

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const _nextUrl = `/${pathSnippets.slice(0, index + 2).join('/')}`;
    if (!breadcrumbNameMap[url]) {
      return null;
    }
    if (!breadcrumbNameMap[_nextUrl]) {
      return (
        <Breadcrumb.Item
          key={url}
          style={{
            color: '#fff',
            fontSize: '16px',
          }}
        >
          {url === '/search' ? (
            <>
              {t('breadcrumb.search')}
              <KeyWord>{_keyWord}</KeyWord>
            </>
          ) : (
            breadcrumbNameMap[url]
          )}
        </Breadcrumb.Item>
      );
    }
    return (
      <Breadcrumb.Item key={url}>
        <Link
          to={url}
          style={{
            fontSize: '16px',
          }}
        >
          {url === '/search' ? (
            <>
              {t('breadcrumb.search')} :<KeyWord>{_keyWord}</KeyWord>
            </>
          ) : (
            breadcrumbNameMap[url]
          )}
        </Link>
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [
    <Breadcrumb.Item key="home">
      <HomeOutlined
        style={{
          fontSize: '16px',
          color: '#4b555e',
        }}
      />
      <Link
        style={{
          fontSize: '16px',
        }}
        to="/"
      >
        {t('home')}
      </Link>
    </Breadcrumb.Item>,
    ...extraBreadcrumbItems,
  ];

  const handleAddTeam = () => {
    navigate('/addteam');
  };
  return (
    <Content>
      {pathSnippets.length > 0 ? (
        <NavFlex>
          <Breadcrumb>{breadcrumbItems}</Breadcrumb>
          {showAddTeam && (
            <Button
              type="text"
              icon={<UserAddOutlined />}
              onClick={handleAddTeam}
            >
              Add Team
            </Button>
          )}
        </NavFlex>
      ) : null}
      {title}
      <Page isPadding={isPadding} pageBG={pageBG}>
        {children}
      </Page>
    </Content>
  );
};

export default PageContent;
